/**
 * Il piede del menu: avatar con le iniziali, nome e societa. Apre una
 * finestra con chi e collegato — email, societa, ruoli con la loro squadra —
 * e l'uscita.
 */

import { ChevronsUpDownIcon, LogOutIcon } from 'lucide-react';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useContesto } from './contesto.js';
import { iniziali, ruoliDi } from './utente.js';

export function MenuUtente() {
  const { utente, squadre, esci } = useContesto();
  const ruoli = ruoliDi(utente, squadre);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="flex w-full items-center gap-3 px-4 py-3 text-left outline-none focus-visible:bg-accent">
        <Avatar size="lg">
          <AvatarFallback className="bg-primary font-semibold text-primary-foreground">
            {iniziali(utente)}
          </AvatarFallback>
        </Avatar>
        <span className="flex min-w-0 flex-1 flex-col">
          <span className="truncate font-semibold">
            {utente.nome} {utente.cognome}
          </span>
          <span className="truncate text-[13px] text-muted-foreground">
            {utente.societa ?? ruoli[0]}
          </span>
        </span>
        <ChevronsUpDownIcon aria-hidden className="size-4 shrink-0 text-muted-foreground" />
      </DropdownMenuTrigger>
      <DropdownMenuContent
        side="top"
        align="start"
        // Parte dall'avatar, non dal bordo del menu: il margine della riga.
        alignOffset={16}
        className="w-(--radix-dropdown-menu-trigger-width) min-w-64"
      >
        <DropdownMenuLabel className="flex items-center gap-3 font-normal">
          <Avatar size="lg">
            <AvatarFallback className="bg-primary font-semibold text-primary-foreground">
              {iniziali(utente)}
            </AvatarFallback>
          </Avatar>
          <span className="flex min-w-0 flex-col">
            <span className="truncate font-semibold text-foreground">
              {utente.nome} {utente.cognome}
            </span>
            <span className="truncate text-muted-foreground">{utente.email}</span>
          </span>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuGroup className="flex flex-col gap-2 px-2 py-1.5 text-sm">
          {utente.societa && (
            <div className="flex flex-col">
              <span className="text-xs text-muted-foreground">Società</span>
              <span>{utente.societa}</span>
            </div>
          )}
          {ruoli.length > 0 && (
            <div className="flex flex-col">
              <span className="text-xs text-muted-foreground">
                {ruoli.length === 1 ? 'Ruolo' : 'Ruoli'}
              </span>
              {ruoli.map((r) => (
                <span key={r}>{r}</span>
              ))}
            </div>
          )}
        </DropdownMenuGroup>
        <DropdownMenuSeparator />
        <DropdownMenuItem onSelect={() => void esci()}>
          <LogOutIcon />
          Esci
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
